const state = {
  data: [],
  activeRecords: [],
  facet: null
}

export default state
